import { formatPercent } from 'helpers/formatters/number_formats';

export default class PercentageFormatter {
  constructor(defaultOptions = {}) {
    this.defaultOptions = defaultOptions;
  }

  format(filterValue, options = {}) {
    options = { ...this.defaultOptions, options };
    return formatPercent(filterValue, options);
  }

  formatRange(filterMinValue, filterMaxValue, options = {}) {
    options = { ...this.defaultOptions, options };

    if (filterMinValue && filterMaxValue) {
      return [filterMinValue, filterMaxValue]
        .map(value => formatPercent(value * 0.01, options))
        .join(' - ');
    } else if (filterMinValue) {
      return `≥ ${formatPercent(filterMinValue * 0.01, options)}`;
    } else if (filterMaxValue) {
      return `≤ ${formatPercent(filterMaxValue * 0.01, options)}`;
    } else {
      return '';
    }
  }
}
